import { ElementRenderer } from '../renderer/elementRenderer';
import widgetStickyManager from '../widgetUIController/widgetStickyManager.js';
import consoleHTML from './../../html/console.html';
import { ScreenManagement } from './screens/screenManagement';
import { LoginScreen } from './screens/loginScreen';
import { ChatScreen } from './screens/chatScreen';
import { GdprScreen } from './screens/gdprScreen';
import { SplashScreen } from './screens/splashScreen';
import { WaitingScreen } from './screens/waitingScreen';
import { TNPSScreen } from "./screens/tnpsScreen";
import { widgetConsole } from "./widgetConsole";
import { ThankYouScreen } from "./screens/thankyouScreen";
import { FeedbackScreen } from "./screens/feedbackScreen";
import { HandoverOfferScreen } from "./screens/handoverOfferScreen";
import { isInApp } from "../utils/isInApp";
import { ConfigurationManager } from "../utils/configurationManager";
import { HistoryDownload } from "./history/historyDownload";
import { LoadingElement } from "./screens/loadingElement";
import { WidgetHeaderController } from "./widgetHeaderController";
import { AOEScreen } from "./screens/aoeScreen";
export class WidgetUIController {
    constructor() {
        // if true, the widget shows the file upload button for the bot conversation
        this.botFileUploadEnabled = true;
        /**
         * Adds html to document
         * @param {*} parent the html div the console should be appended to
         */
        this.bootstrapConsoleHtml = (parent) => {
            let div = document.createElement('div');
            div.innerHTML = consoleHTML;
            parent.appendChild(div);
        };
        /**
         * Set parent element of widget ui
         *
         * @param parent parent element
         */
        this.setParent = (parent) => {
            this.parent = parent;
        };
        /**
         * Set configuration object of widget
         *
         * @param configuration configuration object
         */
        this.setConfiguration = (configuration) => {
            this.configuration = configuration;
        };
        /**
         * Set widget application object
         *
         * @param widget widget application class
         */
        this.setWidgetApplication = (widget) => {
            this.widget = widget;
            this.cachingService = widget.cachingService;
        };
        /**
         * Returns true if widget ui was successfully initialized
         */
        this.isInitialized = () => {
            return this.initialized;
        };
        /**
         * Function creates references to all necessary UI elements
         */
        this.registerWidgetElements = () => {
            this.elements['chatWindow'] = $('.js-chat-window');
            this.elements['minimizeChat'] = $('.js-minimize-chat');
            this.elements['chatWindowContentContainer'] = $('#chatWindow_content');
            this.elements['chatWindowContent'] = $('#chatWindow_content_bot');
            this.elements['chatWindowContentAgent'] = $('#chatWindow_content_agent');
            this.elements['chatWindowContentBot'] = $('#chatWindow_content_bot');
            this.elements['modalDownloadHistory'] = $('#downloadHistory');
            this.elements['historyDownloadModal'] = $('.js-download-modal');
            this.elements['historyDownloadModalText1'] = $('.js-chat-download-text1');
            this.elements['historyDownloadModalText2'] = $('.js-chat-download-text2');
            this.elements['closeHistoryDownloadModal'] = $('.js-popup-history-close');
            this.elements['downloadHistoryDownloadModal'] = $('.js-chat-download-accept');
            this.elements['minimizeIcon'] = $('.cbot-icon-minimize');
            this.elements['closeIcon'] = $('.cbot-icon-close');
            this.elements['downloadIcon'] = $('.cbot-icon-download2');
            // InputField
            this.elements['main_input'] = $('#cbot-chatbotWindowInput');
            this.downloadHistoryLoading = new LoadingElement(this.elements['modalDownloadHistory'].find(".cbot-popup__content"), "downloadHistory");
            this.downloadHistoryLoading.hide();
        };
        /**
         * Loads sticky animation
         */
        this.loadSticky = () => {
            if (this.configuration && this.configuration.chatBotIconVideo) {
                $('div.cbot-chatbotIcon.js-chatbot-icon').html(this.configuration.chatBotIconVideo);
            }
            else {
                if (this.configuration && this.configuration.images &&
                    this.configuration.images.chatbotIconV2 && this.configuration.images.chatbotIconTypeV2) {
                    this.getImageSrc('chatbotIconV2') && $('.js-cdn-chatbotIconV2').attr('srcset', this.getImageSrc('chatbotIconV2'));
                    $('.js-cdn-chatbotIconV2').attr('type', this.configuration.images.chatbotIconTypeV2);
                    $('.js-cdn-chatbotIcon').attr('type', this.configuration.images.chatbotIconType);
                    this.getImageSrc('chatbotIcon') && $('.js-cdn-chatbotIcon').attr('srcset', this.getImageSrc('chatbotIcon'));
                }
                this.getImageSrc('chatbotIcon') && $('.js-cdn-chatbotIcon').attr('src', this.getImageSrc('chatbotIcon'));
            }
        };
        /**
         * Resets images src locations from configuration
         */
        this.resetTemplateImageRessources = () => {
            this.getImageSrc('loginHeader') && $('img.js-cdn-loginHeader').attr('src', this.getImageSrc('loginHeaderFallback'));
            this.getImageSrc('loginHeader') && $('source.js-cdn-loginHeader').attr('srcset', this.getImageSrc('loginHeader'));
            this.getImageSrc('loginHeaderFallback') && $('source.js-cdn-loginHeader-fallback').attr('srcset', this.getImageSrc('loginHeaderFallback'));
            this.getImageSrc('loginAvatar') && $('.js-cdn-loginAvatar.loginAvatar_agent').attr('src', this.getImageSrc('loginAvatar'));
            this.getImageSrc('a1avatar') && $('.js-cdn-a1avatar').attr('src', this.getImageSrc('a1avatar'));
            this.getImageSrc('bannerImg') && $('#cbot-banner-img').attr('src', this.getImageSrc('bannerImg'));
            this.getImageSrc('waitingBannerImg') && $('#cbot-handover-banner-img').attr('src', this.getImageSrc('waitingBannerImg'));
            this.getImageSrc('surveySuccessImg') && $('.cbot-feedback__success img').attr('src', this.getImageSrc('surveySuccessImg'));
        };
        /**
         * Resets template strings from configuration
         */
        this.resetTemplateHardCodedStrings = () => {
            let titles = [
                { 'tags': '#cbot-login-chatwindow .cbot-loader.js-loading-animation', 'key': 'loginViewLoginAnimationIconTitle' },
                { 'tags': '#chatbotWindow .js-minimize-chat', 'key': 'completeChatwindowViewMinimizeIconTitle' },
                { 'tags': '#chatbotWindow .js-close-chat', 'key': 'completeChatwindowCloseIconTitle' },
                { 'tags': '#cbot-complete-chatwindow .cbot-chatWindow__inputfield .cbot-icon-attachment', 'key': 'completeChatwindowViewInputfieldAttachmentIconTitle' },
                { 'tags': '#cbot-complete-chatwindow .cbot-chatWindow__inputfield .cbot-chatInput__send', 'key': 'completeChatwindowViewInputfieldSendMessageIconTitle' },
            ];
            let alts = [
                { 'tags': '.cbot-chatbotIcon .js-chatbot-icon .js-cdn-chatbotIcon', 'key': 'chatbotAlt' },
            ];
            let labels = [
                { 'tags': 'label[for="cbot-vorname"]', 'key': 'loginLabelFirstName' },
                { 'tags': 'label[for="cbot-nachname"]', 'key': 'loginLabelLastName' },
                { 'tags': 'label[for="cbot-email"]', 'key': 'loginLabelEMail' },
                { 'tags': '.cbot-feedback__text label', 'key': 'tnpsSurveyTextFeedbackLabel' },
            ];
            let buttons = [
                { 'tags': 'button.cbot-btn.cbot-btn__primary.js-chat-close', 'key': 'closeWindowViewConfirmButton' },
                { 'tags': 'button.cbot-btn.cbot-btn__secondary.js-popup-close', 'key': 'closeWindowViewDeclineButton' },
                { 'tags': 'button.cbot-btn.cbot-btn__primary.js-chat-download-accept', 'key': 'downloadHistoryViewConfirmButton' },
                { 'tags': 'button.cbot-btn.cbot-btn__secondary.js-popup-history-close', 'key': 'downloadHistoryViewDeclineButton' },
                { 'tags': 'button.cbot-screen__button.cbot-btn.cbot-btn__primary.js-login-btn-submit', 'key': 'loginViewConfirmButton' },
                { 'tags': '.js-gdpr-btn-accept', 'key': 'gdprViewConfirmButton' },
                { 'tags': '.js-gdpr-btn-decline', 'key': 'gdprViewDeclineButton' },
                { 'tags': '#cbot-feedback-tnps__button1', 'key': 'tnpsSurveyNewQuestionButton' },
                { 'tags': '#cbot-feedback-tnps__button2', 'key': 'tnpsSurveySendButton' },
                { 'tags': '#cbot-feedback-thankyou__button1', 'key': 'thankyouFeedbackNewQuestionButton' },
                { 'tags': '#cbot-feedback-thankyou__button2', 'key': 'thankyouFeedbackQuitButton' },
            ];
            let texts = [
                { 'tags': '.cbot-onboarding .cbot-screen__content .cbot-screen__headline', 'key': 'loginHeadline' },
                { 'tags': '.cbot-screen.cbot-screen__paragraph', 'key': 'loginParagraph' },
                { 'tags': '.cbot-input-error.cbot-vorname', 'key': 'loginErrorFirstname' },
                { 'tags': '.cbot-input-error.cbot-nachname', 'key': 'loginErrorNachname' },
                { 'tags': '.cbot-input-error.cbot-email', 'key': 'loginErrorEmail' },
                { 'tags': '#closeWindow .cbot-popup__content .cbot-popup__headline', 'key': 'chatCloseModalQuestionText' },
                { 'tags': '#closeWindow .cbot-popup__content .cbot-popup__text', 'key': 'chatCloseModalInfoText' },
                { 'tags': '#downloadHistory .cbot-popup__content .cbot-popup__headline', 'key': 'downloadHistoryHeadlineText' },
                { 'tags': '#downloadHistory .cbot-popup__content .cbot-popup__text .js-chat-download-text1', 'key': 'downloadHistoryInfoText1' },
                { 'tags': '#downloadHistory .cbot-popup__content .cbot-popup__text .js-chat-download-text2', 'key': 'downloadHistoryInfoText2' },
                { 'tags': '#cbot-waiting-chatwindow .cbot-screen__headline', 'key': 'handoverHeadLine' },
                { 'tags': '#cbot-handoverParagraph', 'key': 'handoverParagraph' },
                { 'tags': '.cbot-handover__time-text', 'key': 'handoverTimeText' },
                { 'tags': '.cbot-alert__content', 'key': 'alertContent' },
                { 'tags': '#cbot-gdpr-chatwindow .cbot-screen__content .cbot-popup__headline', 'key': 'gdprHeadline' },
                { 'tags': '#gdprWindow .cbot-popup__text', 'key': 'gdprInfoText' },
                { 'tags': '#cbot-gdpr-chatwindow .cbot-systemMessage', 'key': 'gdprSystemMessage' },
                { 'tags': '#cbot-gdpr-chatwindow .cbot-bot__message:nth-child(1)', 'key': 'gdprFirstBubble' },
                { 'tags': '#cbot-gdpr-chatwindow .cbot-bot__message:nth-child(2)', 'key': 'gdprSecondBubble' },
                { 'tags': '.cbot-chatWindow__header__title', 'key': 'chatWindowHeadline' },
                { 'tags': '#cbot-banner-text', 'key': 'bannerText' },
                { 'tags': '#cbot-handover-banner-text', 'key': 'waitingBannerText' },
                { 'tags': '#cbot-handover-banner-footer', 'key': 'waitingBannerFooterText' },
                { 'tags': '#cbot-handover-banner-button', 'key': 'waitingBannerButtonText' },
                { 'tags': '.cbot-feedback__prompt .cbot-feedback__subline', 'key': 'tnpsSurveyTitle' },
                { 'tags': '.cbot-feedback__score .text-left', 'key': 'tnpsSurveyLabelBadScore' },
                { 'tags': '.cbot-feedback__score .text-right', 'key': 'tnpsSurveyLabelGoodScore' },
                { 'tags': '.cbot-feedback__success .cbot-feedback__headline', 'key': 'thankyouFeedbackSuccessTitle' },
                { 'tags': '.cbot-feedback__success .cbot-feedback__subline', 'key': 'thankyouFeedbackSuccessSubline' },
                { 'tags': '.cbot-js-aoe-headline', 'key': 'aoeScreenHeadline' },
                { 'tags': '.cbot-js-aoe-subline1', 'key': 'aoeScreenSubline1' },
                { 'tags': '.cbot-js-aoe-subline2', 'key': 'aoeScreenSubline2' },
            ];
            let placeholder = [
                { 'tags': '#cbot-vorname', 'key': 'loginFirstNamePlaceholder' },
                { 'tags': '#cbot-nachname', 'key': 'loginLastNamePlaceholder' },
                { 'tags': '#cbot-email', 'key': 'loginEmailPlaceholder' },
            ];
            titles.forEach(elem => {
                $(elem.tags).attr('title', this.configuration.i18n[elem.key]);
            });
            alts.forEach(elem => {
                $(elem.tags).attr('alt', this.configuration.i18n[elem.key]);
            });
            placeholder.forEach(elem => {
                $(elem.tags).attr('placeholder', this.configuration.i18n[elem.key]);
            });
            labels.forEach(elem => {
                $(elem.tags).html(this.configuration.i18n[elem.key]);
            });
            buttons.forEach(elem => {
                $(elem.tags).html(this.configuration.i18n[elem.key]);
            });
            texts.forEach(elem => {
                $(elem.tags).html(this.configuration.i18n[elem.key]);
            });
            $('#cbot-file-input').attr('accept', this.configuration.uploadMimeAccept);
        };
        /**
         * Returns url for a specific image tag
         *
         * @param srcString tag
         * @returns url for tag `srcString`
         */
        this.getImageSrc = (srcString) => {
            if (srcString && this.configuration && this.configuration.images && this.configuration.images[srcString]) {
                return this.configuration.assetBase + this.configuration.images[srcString];
            }
        };
        /**
         * Initializes debug mode
         */
        this.initDebugMode = () => {
            $('.cbot-versionMessage').show();
            $('.cbot-versionMessage').text(this.widget.version);
        };
        /**
         * Initializes the UI of the widget
         *
         * @param parent html element of the widget
         * @param widget reference to the widget application
         * @param configuration to be used
         */
        this.initializeUI = (parent, widget, configuration) => {
            this.widgetHeaderController = new WidgetHeaderController(widget);
            this.botFileUploadEnabled = widget.state.uploadFileEnabled !== undefined ? widget.state.uploadFileEnabled : false;
            this.setConfiguration(configuration);
            this.setWidgetApplication(widget);
            if (!this.widgetConsole) {
                this.widgetConsole = new widgetConsole(this.widget);
            }
            this.setParent(parent);
            this.stickyManager = new widgetStickyManager(widget);
            this.initScreens();
            this.registerWidgetElements();
            this.resetTemplateHardCodedStrings();
            this.loadSticky();
            // top icons can be switched off using options (state)
            if (!!this.widget.getStateMachine().hideIcons) {
                this.widgetHeaderController.disableMinimizeIcon();
            }
            if (!!configuration.debugMode) {
                this.initDebugMode();
            }
            if (!this.isMobile()) {
                this.stickyManager.showAlertMessage();
            }
            this.registerEventHandler();
            this.resetContent();
            this.initialized = true;
        };
        this.initScreens = () => {
            this.screenManagement = new ScreenManagement(this);
            this.loginScreen = new LoginScreen(this);
            this.splashScreen = new SplashScreen(this);
            this.waitingScreen = new WaitingScreen(this);
            this.gdprScreen = new GdprScreen(this);
            this.chatScreen = new ChatScreen(this);
            this.tnpsScreen = new TNPSScreen(this);
            this.thankYouScreen = new ThankYouScreen(this);
            this.feedbackScreen = new FeedbackScreen(this);
            this.handoverOfferScreen = new HandoverOfferScreen(this);
            this.aoeScreen = new AOEScreen(this);
            this.screenManagement.addScreen(this.chatScreen);
            this.screenManagement.addScreen(this.loginScreen);
            this.screenManagement.addScreen(this.waitingScreen);
            this.screenManagement.addScreen(this.gdprScreen);
            this.screenManagement.addScreen(this.splashScreen);
            this.screenManagement.addScreen(this.tnpsScreen);
            this.screenManagement.addScreen(this.thankYouScreen);
            this.screenManagement.addScreen(this.feedbackScreen);
            this.screenManagement.addScreen(this.handoverOfferScreen);
            this.screenManagement.addScreen(this.aoeScreen);
        };
        /**
         * Hide minimize Icon
         */
        this.hideMinimizeIcon = () => {
            this.widgetHeaderController.hideMinimizeIcon();
        };
        /**
         * Show minimize Icon
         */
        this.showMinimizeIcon = () => {
            this.widgetHeaderController.showMinimizeIcon();
        };
        /**
         * Hide minimize Icon
         */
        this.hideCloseIcon = () => {
            this.widgetHeaderController.hideCloseIcon();
        };
        /**
         * Show minimize Icon
        */
        this.showCloseIcon = () => {
            this.widgetHeaderController.showCloseIcon();
        };
        /**
         * Hide minimize Icon
        */
        this.hideDownloadIcon = () => {
            this.widgetHeaderController.hideDownloadIcon();
        };
        /**
         * Show minimize Icon
        */
        this.showDownloadIcon = () => {
            this.widgetHeaderController.showDownloadIcon();
        };
        /**
         * Returns true if user agent is mobile
         */
        this.isMobile = () => {
            var check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };
        /**
         * Function registeres all necessary event handlers
         */
        this.registerEventHandler = () => {
            // -----------------------------------------------------------------------------
            //                             MINIMIZE / OPEN CHAT
            // -----------------------------------------------------------------------------
            this.elements['minimizeChat'].on('click', () => {
                // Minimize Chat
                this.widget.track("chat", "minimize", this.widget.getStateMachine().screen + "_screen");
                this.toggleChatWindowVisibility(false);
                this.stickyManager.minimize(true);
            });
            this.elements['historyDownloadModal'].on('click', () => {
                this.widget.track("chat", "History_Download", "Klick");
                this.elements['modalDownloadHistory'].toggleClass('cbot-popup--visible');
            });
            this.elements['closeHistoryDownloadModal'].on('click', () => {
                this.widget.track("chat", "History_Download", "Nein");
                this.elements['modalDownloadHistory'].toggleClass('cbot-popup--visible');
            });
            this.elements['downloadHistoryDownloadModal'].on('click', () => {
                this.widget.track("chat", "History_Download", "Ja");
                this.elements['closeHistoryDownloadModal'].hide();
                this.elements['downloadHistoryDownloadModal'].hide();
                this.elements['historyDownloadModalText1'].hide();
                this.elements['historyDownloadModalText2'].show();
                this.downloadHistoryLoading.show();
                let interactionId = this.widget.cachingService.interactionId;
                let fontURL = "";
                fontURL = ConfigurationManager.setValueIfExists(this.configuration, "fonts.a1sans", fontURL);
                if (fontURL) {
                    fontURL = this.configuration.assetBase + fontURL;
                }
                else {
                    fontURL = "https://cdn11.a1.net/assetsup/theme-a1/last/fonts/a1sans/A1Sans-Regular.woff";
                }
                let apiURL = "https://www.a1.net/kara/history";
                apiURL = ConfigurationManager.setValueIfExists(this.configuration, "endpoints.historyDownload", apiURL);
                HistoryDownload.downloadHistory(document.getElementById("chatWindow_content"), this.widget.cachingService.chatStartTimestamp, interactionId, apiURL, fontURL).finally(() => {
                    this.elements['modalDownloadHistory'].toggleClass('cbot-popup--visible');
                    this.elements['closeHistoryDownloadModal'].show();
                    this.elements['downloadHistoryDownloadModal'].show();
                    this.elements['historyDownloadModalText1'].show();
                    this.elements['historyDownloadModalText2'].hide();
                    this.downloadHistoryLoading.hide();
                });
            });
        };
        /**
         * Creates and shows a system message in the chat that origin is not from genesys but from the widget itself
         *
         * @param text to be shown as a system message
         */
        this.createSystemMessage = (text) => {
            let renderer = new ElementRenderer(this.configuration);
            renderer.addSystemMessage(text);
            let systemMessage = renderer.getResult();
            this.widget.saveMessageToCache(systemMessage);
            this.chatScreen.appendTextToChatbox(systemMessage, this.elements['chatWindowContent'], true, 'system');
        };
        /**
         * Transfer to waiting screen after some time
         *
         * @param waitingTime in seconds
         */
        this.transferToWaitingScreen = (waitingTime) => {
            this.waitingScreen.switchToWaitingScreen(waitingTime);
        };
        /**
         * Min/Max Chat window
         * @param maximize if true maximizes the chat window, else minimizes it
         */
        this.toggleChatWindowVisibility = (maximize) => {
            if (this.elements['chatWindow'].hasClass('cbot-chatWindow--visible') && !maximize) {
                this.enableBodyScrolling();
                this.elements['chatWindow'].toggleClass('cbot-chatWindow--visible');
                this.stickyManager.showSticky(() => { this.stickyManager.minimize(true); });
            }
            else if (!this.elements['chatWindow'].hasClass('cbot-chatWindow--visible') && maximize) {
                this.disableBodyScrolling();
                this.stickyManager.hideSticky(() => { this.stickyManager.minimize(false); });
                this.elements['chatWindow'].toggleClass('cbot-chatWindow--visible');
                this.chatScreen.scrollToBottom();
            }
            this.screenManagement.resizeActiveScreen();
        };
        /**
        *  Depending on the target, the onboarding will look different.
        *
        *  @param target for a specific onboarding
        *
        *  Allowed values:
        *
        *  "agent", "bot", "unknown", "gdpr", "handover"
        */
        this.setOnboarding = (target) => {
            // hard code bot to onboarding
            const data = {
                agent: {
                    icon_on: 'agent',
                    icon_off: 'bot',
                    icon: this.getImageSrc('loginAvatar'),
                    headline: this.configuration.i18n['loginHeadline'],
                    subline: this.configuration.i18n['loginSubline']
                },
                bot: {
                    icon_on: 'bot',
                    icon_off: 'agent',
                    icon: this.getImageSrc('loginAvatarBot'),
                    headline: this.configuration.i18n['loginHeadlineBot'],
                    subline: this.configuration.i18n['loginSublineBot']
                },
                unknown: {
                    icon_on: 'bot',
                    icon_off: 'agent',
                    icon: this.getImageSrc('loginAvatarBot'),
                    headline: this.configuration.i18n['loginHeadline'],
                    subline: this.configuration.i18n['loginSubline']
                },
                gdpr: {
                    icon_on: 'bot',
                    icon_off: 'agent',
                    icon: this.getImageSrc('loginAvatarBot'),
                    headline: this.configuration.i18n['loginHeadlineBot'],
                    subline: this.configuration.i18n['loginSublineBot']
                },
                waiting: {
                    icon_on: 'agent',
                    icon_off: 'bot',
                    icon: this.getImageSrc('a1avatar'),
                    headline: this.configuration.i18n['handoverHeadline'],
                    subline: this.configuration.i18n['handoverSubline']
                },
                splash: {
                    icon_on: 'bot',
                    icon_off: 'agent',
                    icon: this.getImageSrc('loginAvatarBot'),
                    headline: this.configuration.i18n['loginHeadlineBot'],
                    subline: this.configuration.i18n['loginSublineBot']
                },
            };
            let ctl = data.hasOwnProperty(target) ? data[target] : data['agent'];
            $('.cbot-chatWindow img.js-cdn-loginAvatar.loginAvatar_' + ctl.icon_on).show();
            $('.cbot-chatWindow img.js-cdn-loginAvatar.loginAvatar_' + ctl.icon_off).hide();
            if (undefined !== ctl.headline)
                $('.cbot-onboarding .cbot-screen__headline').html(ctl.headline);
            if (undefined !== ctl.subline)
                $('.cbot-onboarding .cbot-screen__subline').html(ctl.subline);
        };
        /**
         * Prevents the background site to be scrolled
         */
        this.disableBodyScrolling = () => {
            if (this.isMobile()) {
                $('body').addClass('cbot-noScrolling');
            }
        };
        /**
         * Set active chatWindowContent container
         * @param botContainer if true, set bot container active, otherwise agent container will be active
         */
        this.setActiveContainer = (botContainer) => {
            if (botContainer) {
                this.elements['chatWindowContent'] = this.elements['chatWindowContentBot'];
            }
            else {
                this.elements['chatWindowContent'] = this.elements['chatWindowContentAgent'];
            }
        };
        /**
         * Set the UI to a bot view mode
         */
        this.activateBotView = () => {
            this.chatScreen.hideUploadIcon();
            this.widget.canUpload().then((canUpload) => {
                this.widget.canUploadAgentOnly().then((canUploadAgentOnly) => {
                    if (canUpload && !canUploadAgentOnly && this.botFileUploadEnabled) {
                        this.chatScreen.showUploadIcon();
                    }
                    else {
                        this.chatScreen.hideUploadIcon();
                    }
                });
            });
            this.chatScreen.setMaxMessageLength(this.configuration.chatbotMaxMessageLength);
        };
        /**
         * Disable bot view mode
         */
        this.deactivateBotView = () => {
            this.chatScreen.hideUploadIcon();
            this.widget.canUpload().then((canUpload) => {
                if (canUpload) {
                    this.chatScreen.showUploadIcon();
                }
                else {
                    this.chatScreen.hideUploadIcon();
                }
            });
            this.chatScreen.setMaxMessageLength();
            this.deactivateExtension('iframe');
        };
        /**
         * Activate chat.
         * Should be called when the user will be interacting with the chat/widget itself.
         */
        this.activateChat = () => {
            this.active = true;
            this.loadBotPersonaMorph();
            this.resetTemplateImageRessources();
            // Hide tag on active chat
            $('.cbot-chatbotIconTag').hide();
            this.stickyManager.setChatActive(true);
        };
        /**
         * Loads Bot Avatar if not already loaded
         */
        this.loadBotPersonaMorph = () => {
            if (this.getImageSrc('loginAvatarBot') && !this.isPersonaLoaded) {
                this.isPersonaLoaded = true;
                $('.js-cdn-loginAvatar.loginAvatar_bot').attr('src', this.getImageSrc('loginAvatarBot'));
            }
        };
        /**
         *  Should be called when chat lost connection.
         *
         *  Disables input and shows alert message
         */
        this.chatDisconnected = () => {
            this.chatScreen.disableInput();
            this.chatScreen.showAlert(this.configuration.i18n.chatDisconnectedAlertMessage);
        };
        /**
         * Process UI changes for ending a chat session
         */
        this.endChatSession = () => {
            if (this.chatScreen) {
                this.chatScreen.hideTyping();
            }
            if (!this.widget.getStateMachine().hideIcons) {
                if (this.widget.isMessageContainerEmpty()) {
                    // no messages, we close chat completely
                    this.close();
                    return;
                }
            }
            else {
                this.widgetHeaderController.disableCloseIcon();
                this.widgetHeaderController.disableMinimizeIcon();
            }
            this.screenManagement.deactivateExtensions();
            this.chatScreen.showAlert(this.configuration.i18n.chatHasEndedAlertMessage);
            this.disableButtons();
            this.showScreen('chat');
            this.elements['main_input'].hide();
        };
        /**
         * Resets and initializes content elements
         */
        this.resetContent = () => {
            this.chatScreen.resetContent();
        };
        this.elements = {};
        this.initialized = false;
        this.isPersonaLoaded = false;
        this.active = false;
        /**
         * Detects a change of screen size and propagates it to the active window
         */
        window.addEventListener('resize', () => {
            // when the screen size changes, we remove all styles from the main dom element (widget drag information)
            $('#chatbotWindow').removeAttr("style");
            if (this.screenManagement) {
                this.screenManagement.resizeActiveScreen();
            }
        });
        this.bootstrapConsoleHtml(document.body);
    }
    /**
     * Shows a specific screen to the user
     * @param screen to be shown
     */
    showScreen(screen, options) {
        this.screenManagement.showScreen(screen, options);
        if (!this.isMobile() || this.widget.getStateMachine().loginNotice || isInApp()) {
            this.toggleChatWindowVisibility(true);
        }
    }
    /**
     * Activates an extension in all screens that implement it
     * @param extensionName name of the extension
     * @param extensionOptions  options that are passed to the extension
     */
    activateExtension(extensionName, extensionOptions) {
        this.screenManagement.activateExtension(extensionName, extensionOptions);
        this.widget.cachingService.saveCacheSession(this.widget.getStateMachine());
    }
    /**
     * Deactivates an extension in all screens that implement it
     * @param extensionName name of the extension
     */
    deactivateExtension(extensionName) {
        this.screenManagement.deactivateExtension(extensionName);
        this.widget.cachingService.saveCacheSession(this.widget.getStateMachine());
    }
    /**
     * Disable all buttons which should not be active when the chat is closed
     */
    disableButtons() {
        $(".cbot-download__buttons").prop("disabled", true);
        $(".jsClickableCommandButton").prop("disabled", true);
        $(".jsClickableCommandButton").parent().addClass("disabled");
    }
    close() {
        this.widgetHeaderController.reset();
        if (this.deactivated) {
            this.reset();
        }
        else {
            if (this.widget.getStateMachine().mode == 'button' || this.widget.getStateMachine().mode == 'autoOpen') {
                this.stickyManager.hideSticky(undefined);
            }
            this.stickyManager.close();
            this.widget.close();
        }
    }
    /**
     * Allow the background site to be scrolled
     */
    enableBodyScrolling() {
        $('body').removeClass('cbot-noScrolling');
    }
    appendMessageToBotContainer(message, user) {
        this.chatScreen.appendTextToChatbox(message, this.elements['chatWindowContentBot'], true, user);
    }
    appendMessageToAgentContainer(message, user) {
        this.chatScreen.appendTextToChatbox(message, this.elements['chatWindowContentAgent'], true, user);
    }
    /**
    * Appends the reponse from the chatbot in the chat agent window
    * @param {*} botResponse rendered bot response
    */
    appendAgentTextToChatbox(agentResponse) {
        this.chatScreen.appendTextToChatbox(agentResponse, this.elements['chatWindowContentAgent']);
    }
    /**
     * Appends the reponse from the chatbot in the chat bot window
     * @param {*} botResponse rendered bot response
     */
    appendBotTextToChatbox(botResponse) {
        this.chatScreen.appendTextToChatbox(botResponse, this.elements['chatWindowContentBot']);
    }
    /**
     * Should be called when chat restores the connection
     *
     * Enables Input and hides all alerts
     */
    chatReconnected() {
        this.chatScreen.enableInput();
        this.chatScreen.hideAlert();
    }
    /**
    * Resets the User Interface Controller to its original state and unregisters all event handlers if there are any
    */
    reset() {
        this.unregisterEventHandler();
        this.parent.innerHTML = '';
        this.elements = {};
        this.isPersonaLoaded = false;
        this.active = false;
        this.initialized = false;
        this.stickyManager.setChatActive(false);
        this.enableBodyScrolling();
    }
    /**
     * Function registeres all necessary event handlers
     */
    unregisterEventHandler() {
        $('.js-chat-window > *').off();
    }
    /**
     * Resets the User Interface Controller to its minimized state
     */
    resetSticky() {
        this.resetContent();
        this.chatScreen.hideUnreadMessagesNotification();
        this.chatScreen.enableInput();
        this.toggleChatWindowVisibility(false);
        this.chatScreen.hideAlert();
        this.enableBodyScrolling();
        this.isPersonaLoaded = false;
        this.stickyManager.setChatActive(false);
        this.active = false;
    }
    /**
     * Deactivates ui, no new chat can be started
     */
    deactivateUI() {
        this.deactivated = true;
    }
}
